<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardBody>
          <h3>
            Edit Note id:  {{ $route.params.id }}
          </h3>
          <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
            <CInput label="Τίτλος" type="text" id="title" placeholder="Τίτλος" v-model="note.title"/>
            <CInput
              label="Περιεχόμενο"
              placeholder="Περιεχόμενο.."
              
              textarea="true"
              rows="9"
              v-model="note.content"
            />
            <CInput label="Ημερομηνία" type="date" id="applies_to_date" v-model="note.applies_to_date"/>
            <CSelect 
              id="status_id" 
              :value.sync="note.status_id"
              :options="statuses"
              label="Κατάσταση"
            />
            <CInput label="Τύπος σημείωσης" placeholder="Τύπος σημείωσης" type="text" id="note_type" v-model="note.note_type"></CInput>
       
          <CButton color="primary" @click="update()">Αποθήκευση</CButton>
          <CButton color="primary" @click="goBack">Πίσω</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
export default {
  name: 'EditUser',
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  data: () => {
    return {
        note: {
          title: '',
          content: '',
          applies_to_date: '',
          status_id: null,
          note_type: '',
        },
        // status_id: null,
        statuses: [],
        message: '',
        alertIsShown: false,
        dismissSecs: 7,
        dismissCountDown: 0,
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    update() {
        let self = this;
        axios.post('/api/notes/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
        {
            _method: 'PUT',
            title:            self.note.title,
            content:          self.note.content,
            applies_to_date:  self.note.applies_to_date,
            status_id:        self.note.status_id,
            note_type:        self.note.note_type
        })
        .then(function (response) {
            self.message = 'Επιτυχής επεξεργασία σημείωσης.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error); 
              self.$router.push({ path: '/login' }); 
            }
        });
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function(){
    let self = this;
    axios.get('/api/notes/' + self.$route.params.id + '/edit?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
        self.note = response.data.note;
        self.statuses = response.data.statuses;
        self.$forceUpdate()
    }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
    });
  }
}

/*
      items: (id) => {
        const user = usersData.find( user => user.id.toString() === id)
        const userDetails = user ? Object.entries(user) : [['id', 'Not found']]
        return userDetails.map(([key, value]) => {return {key: key, value: value}})
      },
*/

</script>
